export default "__VITE_ASSET__DBwKdEDA__"